<div class="sidebar-plain-wrap">
  <div class="sidebar-plain-container">
    <!-- Logo -->
    <div class="logo-container">
      <div class="logo">
        <img src="/assets/images/logo-imperial.png" alt="">
      </div>
    </div>

    <!-- Navigation Menu -->
    <div class="sidebar-plain-navigation">
      <!-- Main Menu Categories -->
      <!-- <div class="menu-category mb-4">
        <span>OVERVIEW</span>
      </div> -->
     <ul class="main-menu">
    @for (item of navService.menuItems$ | async; track item) {
      <li class="nav-item" 
          [ngClass]="{'active': isItemActive(item)}">
        @if (item.type === 'dropDown') {
          <div>
            <a class="nav-link d-flex align-items-center justify-content-between" 
               [ngClass]="{open: item.active}"
               (click)="selectItem(item)">
              <div class="d-flex align-items-center">
                <i [class]="'nav-icon ' + item.icon"></i>
                <span class="item-name">{{ item.name }}</span>
              </div>
              <i class="i-Arrow-Down dd-arrow"></i>
            </a>
            <!-- Dropdown Items -->
            <div class="submenu" [ngClass]="{open: item.active}">
              <ng-container *ngTemplateOutlet="menuTemplate; context: { parentItem: item }"></ng-container>
            </div>
          </div>
        }
        @if (item.type === 'link') {
          <a class="nav-link d-flex align-items-center" 
             routerLink="{{ item.state }}" 
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: false}"
             #rla="routerLinkActive"
             (click)="selectItem(item)">
            <i [class]="'nav-icon ' + item.icon"></i>
            <span class="item-name">{{ item.name }}</span>
          </a>
        }
      </li>
    }
</ul>
    </div>
  </div>
</div>

<!-- Recursive Template for Dropdown Menus -->
<ng-template #menuTemplate let-parentItem="parentItem">
  <ul class="childNav">
    @for (item of parentItem?.sub; track item) {
      <li appDropdownLink class="nav-item" [ngClass]="{active: item.active}">
        @if (item.type === 'link') {
          <a routerLink="{{ item.state }}" class="" routerLinkActive="open">
            @if (item.icon) {
              <i [class]="'nav-icon ' + item.icon"></i>
            }
            <span class="item-name lvl1">{{ item.name }}</span>
          </a>
        }
        @if (item.type === 'dropDown') {
          <div>
            <a appDropdownToggle class="justify-content-between pointer" [ngClass]="{ open: item.active }" (click)="toggleSubmenu(item, $event)">
              <div>
                @if (item.icon) {
                  <i [class]="'nav-icon ' + item.icon"></i>
                }
                <span class="item-name">{{ item.name }}</span>
              </div>
              <i class="dd-arrow i-Arrow-Down"></i>
            </a>
            <div class="submenu" [ngClass]="{open: item.active}">
              <ng-container *ngTemplateOutlet="menuTemplate; context: { parentItem: item }"></ng-container>
            </div>
          </div>
        }
      </li>
    }
  </ul>
</ng-template>
